'use strict';

var tabform = angular.module('gymsystem.tabform', []);

tabform.directive('tabform', ['util', 'server', '$rootScope', function (util, server, $rootScope) {
    return {
        restrict: 'E',
        templateUrl: 'views/tabform.html',
        scope: {
            config: '='
        },
        link: function(scope) {
            scope.getCustomerForField = $rootScope.getCustomerForField;
            scope.getMultiFieldBuilderForField = $rootScope.getMultiFieldBuilderForField;
            scope.getFieldBuilderForField = $rootScope.getFieldBuilderForField;
            scope.getCustomersForField = $rootScope.getCustomersForField;
            scope.getAccountsForField = $rootScope.getAccountsForField;
            scope.getCashierForField = $rootScope.getCashierForField;
            scope.getPaymentMethodForField = $rootScope.getPaymentMethodForField;
            scope.getItemListText = $rootScope.getItemListText;
            scope.getProductsForField = $rootScope.getProductsForField;
            scope.memberImage = $rootScope.memberImage;
            scope.getGroupForField = $rootScope.getGroupForField;
            scope.getGroupsForField = $rootScope.getGroupsForField;

            scope.getFieldsForTab = function(tab) {
                return tab.fields;
            };

            scope.getTitleForTab = function(tab) {
                if (!tab.getTitle) {
                    tab.getTitle = function(name) {
                        if (name) {
                            return _.findWhere(tab.fields.filter(function(f) { return !f.visible || f.visible(); }), {name: util.getRealFormName(name)}).title;
                        }
                    };
                    return tab.getTitle;
                }
            };

            scope.getNumberOfMissingRequiredFields = function(tab) {
                return tab.fields.filter(function(field) {
                    if (field.required && (!field.visible || field.visible(field))) {
                        return field.value == null || field.value.length == 0;
                    }
                    return false;
                }).length + (tab.getAdditionalMissingCount ? tab.getAdditionalMissingCount() : 0);
            };

            function getField(name) {
                for (var i=0; i < scope.config.tabs.length; ++i) {
                    var tab = scope.config.tabs[i];
                    for (var j=0; j < tab.fields.length; ++j) {
                        var field = tab.fields[j];
                        if (field.name == name) {
                            return field;
                        }
                    }
                }
            }

            scope.config.control = {
                getTab: function(name) {
                    return _.findWhere(scope.config.tabs, {name: name});
                },
                setActiveTab: function(tab) {
                    angular.forEach(scope.config.tabs, function(ftab) {
                        ftab.active = tab == ftab;
                    });
                },
                getField: function(name) {
                    return getField(name);
                },
                getFields: function(only_visible) {
                    var res = [];
                    for (var i=0; i < scope.config.tabs.length; ++i) {
                        var tab = scope.config.tabs[i];
                        if (!only_visible || !tab.visible || tab.visible()) {
                           res = res.concat(tab.fields);
                        }
                    }
                    return res;
                },
                getFieldsForTab : function(tabname) {
                    return scope.config.control.getTab(tabname).fields;
                },
                getSubmitItem: function() {
                    var item = {};
                    if (scope.config.item) {
                        item.id = scope.config.item.id;
                    }
                    var fields = scope.config.control.getFields(true);
                    for (var i=0; i < fields.length; ++i) {
                        var field = fields[i];
                        if (!field.type || !field.name || (field.visible && !field.visible(field) && !field.save)) {
                            continue;
                        }
                        var value = util.getValueForField(field);
                        if (field.splitted_name && field.splitted_name.length > 0) {
                            var sn = field.splitted_name;
                            if (!item[sn[0]]) {
                                item[sn[0]] = {};
                            }
                            item[sn[0]][sn[1]] = value;
                        } else if (field.name.indexOf('.') != -1) {
                            var parts = field.name.split('.');
                            if (!item[parts[0]]) {
                                item[parts[0]] = {};
                            }
                            item[parts[0]][parts[1]] = value;
                        } else {
                            item[field.name] = value;
                        }
                    }
                    return item;
                },
                canSubmit: function() {
                    if (!_.all(scope.config.tabs.filter(function(tab){ return !tab.visible || tab.visible(); }), function(tab) { return scope.getNumberOfMissingRequiredFields(tab) == 0; })) {
                        return false;
                    }

                    var changed = false;
                    if (scope.config.item) {
                        changed = _.find(scope.config.control.getFields(true), function(field) { return util.valueChanged(field, scope.config.item); });
                        if (!changed && scope.config.changed) {
                            changed = scope.config.changed();
                        }
                    }

                    return (!scope.config.item || changed) && (!scope.config.canSubmit || scope.config.canSubmit());
                },
                submit: function() {
                    if (!scope.config.loadingStatus) {
                        scope.config.loadingStatus = {};
                    }

                    scope.config.loadingStatus.loading = true;
                    var item = scope.config.getSubmitItem ? scope.config.getSubmitItem() : scope.config.control.getSubmitItem();

                    if (scope.config.beforeSubmit) {
                        scope.config.beforeSubmit(item).then(scope.config.control.doSubmit, function() {
                            scope.config.loadingStatus.loading = false;
                        });
                    } else {
                        scope.config.control.doSubmit(item);
                    }
                },
                doSubmit: function(item) {
                    if (!scope.config.url || !scope.config.url[scope.config.mode]) {
                        if (scope.config.afterSubmit) {
                            scope.config.afterSubmit(item);
                        }
                        return;
                    }

                    var failedTitle = scope.config.submitFailed ? undefined : (scope.config.failedTitle || 'Failed to add item');

                    server.post(scope.config.url[scope.config.mode], item, null, scope.config.successTitle || 'Item added', failedTitle, scope.config.itemTitle).then(function(result) {
                        scope.config.loadingStatus.loading = false;
                        if (result.success) {
                            if (scope.config.afterSubmit) {
                                scope.config.afterSubmit(result.data);
                            }
                        } else {
                            if (scope.config.submitFailed) {
                                scope.config.submitFailed(result.data);
                            }
                        }
                    });
                },
                valuesChangedOrEntered: function() {
                    if (scope.config.item) {
                        var changed = !!_.find(scope.config.control.getFields(true), function(field) {
                            const fieldWasChanged = util.valueChanged(field, scope.config.item);

                            // To debug unwanted "Are you sure you want to close" dialogs, uncomment the following lines

                            //if (fieldWasChanged) {
                            //    console.log('Field changed: ' + field.name + ' (' + field.type + ')');
                            //}
                            return fieldWasChanged;
                        });
                        if (!changed && scope.config.changed) {
                            changed = scope.config.changed();
                        }
                        return changed;
                    } else {
                        var changed = function(s) {
                            for(var cs = s.$$childHead; cs; cs = cs.$$nextSibling) {
                                if (cs.form) {
                                    if (!cs.form.$pristine) {
                                        return true;
                                    }
                                }

                                if (changed(cs)) {
                                    return true;
                                }
                            }
                        };

                        return changed(scope);
                    }
                }
            };

            var callInit = function() {
                var res = (scope.config.init && scope.config.init()) || {};
                _.extend(res, scope.config.item);
                _.extend(res, scope.config.initial);
                if (res) {
                    var option = scope.config.initCallChange ? {callChange: true} : null;
                    util.setValues(scope.config.control.getFields(), res, option);
                }
                if (scope.config.afterInit) {
                    scope.config.afterInit(res);
                }
                scope.config.initialized = true;
            };

            var makeVisibleFunction = function(x) {
                if (x.visible && _.isString(x.visible)) {
                    var not = x.visible.startsWith('!');
                    var other_field = scope.config.control.getField(x.visible.replace('!', ''));
                    x.visible = function() {
                        return not ? !other_field.value : other_field.value;
                    };
                }
            };

            scope.config.control.getFields().forEach(makeVisibleFunction);
            scope.config.tabs.forEach(makeVisibleFunction);

            var promises = _.keys(scope.config.data || {}).filter(function(k) {
                var p = scope.config.data[k];
                return p && p.then;
            });
            var replacePromisesWithData = function() {
                var left = promises.length;
                promises.forEach(function(datakey) {
                    scope.config.data[datakey].then(function(data) {
                        scope.config.data[datakey] = data;

                        --left;
                        if (!left) {
                            callInit();
                        }
                    });
                });
                /*for (var i=0; i < scope.config.tabs.length; ++i) {
                    var tab = scope.config.tabs[i];
                    tab.fields.forEach(function(field) {
                        if ((field.type == 'select' || field.type == 'multiselect') && field.options) {
                            var o = field.options();
                            if (o.then) {
                                o.then(function(data) {
                                    field.options = function() { return data; }
                                    promises -= 1;
                                    if (promises == 0) {
                                        callInit();
                                    }
                                });
                            }
                        }
                    });
                }*/
            };

            if (promises.length) {
                replacePromisesWithData();
            } else {
                callInit();
            }
        }
    };
}]);
